import React from "react";
import styled from "styled-components";
import { ImgDefault } from "../../../images";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faPlay } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export const Department = ({
  banner,
  title,
  titleLarge,
  url,
  externalUrl,
  opcional,
  disabled = false,
  badgeText,
}) => {
  const navigate = useNavigate();

  const onNavigateTo = () => {
    if (disabled) return;
    if (url) return navigate(url);
    if (externalUrl) return window.open(externalUrl, "_blank");
  };

  return (
    <Container $disabled={disabled}>
      <div className="item-picture" onClick={onNavigateTo}>
        <img
          src={banner || ImgDefault}
          alt="ImageBanner"
          className={opcional && "opcional-image"}
        />
        <h2 className="item-department-name">{title}</h2>
      </div>

      {disabled && (
        <div className="disabled-overlay">
          <div className="badge-soon">
            {badgeText || "Pronto se habilitará"}
          </div>
        </div>
      )}

      <div className="item-title-card">
        <h4> {titleLarge} </h4>
      </div>
      <div className="footer-card">
        <div className="blog-divider-wrapper">
          <div className="blog-divider" />
        </div>
        <div className="item-bottom">
          <div className="item-more">
            <div className="bottom-txt">
              {!disabled && externalUrl && (
                <a href={externalUrl} target="_blank" rel="noreferrer">
                  <h5>Web url</h5>
                  <FontAwesomeIcon icon={faLink} />
                </a>
              )}
              {!disabled && url && (
                <span onClick={onNavigateTo}>
                  <h5>Ver más</h5> <FontAwesomeIcon icon={faPlay} />
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  background: radial-gradient(100% 100% at 50.52% 0%, #686868 0%, #000000 100%);
  box-shadow: 0 10px 20px rgb(0 0 0 / 5%);
  border-radius: 8px;
  min-height: 25rem;
  max-height: 25rem;
  width: 100%;
  overflow: hidden;

  /* Overlay general para oscurecer la tarjeta cuando está deshabilitada */
  .disabled-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 14rem; /* Mismo alto que la sección de la imagen */
    background: rgba(0, 0, 0, 0.75);
    z-index: 25;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
    cursor: not-allowed;
  }

  .badge-soon {
    background: rgba(39, 174, 96, 0.95);
    color: #ffffff;
    font-weight: 700;
    font-size: 0.9rem;
    padding: 10px 18px;
    border-radius: 6px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6);
    border: 2px solid rgba(255, 255, 255, 0.9);
    text-align: center;
    white-space: nowrap;
    transform: rotate(-3deg);
  }

  .item-picture {
    position: relative;
    transition: all 0.3s ease;
    z-index: 0;
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
    cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};

    &:before {
      content: "";
      background: rgba(0, 0, 0, 0.35);
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    img {
      width: 100%;
      height: 14rem;
      object-fit: cover;
    }

    .opcional-image {
      object-position: top;
    }

    .item-department-name {
      color: #fff;
      font-size: 2.3rem;
      text-align: center;
      position: absolute;
      margin: auto;
      text-transform: uppercase;
      font-family: "AudiowideRegular", serif;
      z-index: 2;
    }
  }

  .item-title-card {
    width: 100%;
    height: auto;
    min-height: 5.5rem;
    padding: 1rem 0.7rem;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    h4 {
      margin: 0;
    }
  }

  .footer-card {
    position: absolute;
    z-index: 10;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    transition: all 0.3s ease;
    padding: 26px 20px;
    color: #ffffff;

    .blog-divider-wrapper {
      position: relative;
      width: 100%;
      height: 10px;
      z-index: 0;

      &:after {
        content: " ";
        position: absolute;
        top: 0;
        left: 93%;
        bottom: 0;
        width: 75px;
        height: 1px;
        background-color: #b3b6b7;
        z-index: 1;
        -webkit-transform: rotate(47deg);
        transform-origin: 0% 0%;
        transition: all 0.3s ease;
      }

      .blog-divider {
        &:before {
          content: " ";
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 65px;
          height: 6px;
          background-color: #b3b6b7;
          z-index: 1;
          transition: all 0.3s ease;
        }

        &:after {
          content: " ";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          width: 93%;
          height: 1px;
          background-color: #b3b6b7;
          z-index: 1;
          transition: all 0.3s ease;
        }
      }
    }

    .item-bottom {
      width: 100%;
      height: auto;
      position: relative;

      .item-more {
        position: relative;

        .bottom-txt {
          margin: 1.7rem 0 0 0;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          a,
          span {
            display: flex;
            align-items: center;
            color: #fff;
            margin-right: 0.9rem;
            cursor: pointer;

            h5 {
              margin: 0 0.3rem 0 0;
            }
          }
        }
      }
    }
  }
`;
